let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1HhHN")).then(() => parcelRequire('lS9G7'));